import { useEffect, useRef } from "react";

import { variablesGlobales } from "../../../../configs/variables";

export function WompiCheckout({ amountInCents, reference, signature, email, fullName, phone, autoSubmit = false }) {
  const formRef = useRef(null);
  const hasSubmittedRef = useRef(false);
  const redirectUrl = variablesGlobales.urlRedirectCobre;
  const checkoutRedirectUrl =
    redirectUrl && !/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(redirectUrl)
      ? redirectUrl
      : "";

  useEffect(() => {
    if (autoSubmit && !hasSubmittedRef.current) {
      hasSubmittedRef.current = true;
      formRef.current?.submit();
    }
  }, [autoSubmit]);

  return (
    <form
      ref={formRef}
      action="https://checkout.wompi.co/p/"
      method="GET"
      style={{
        width: "100%",
        display: autoSubmit ? "none" : "flex",
        justifyContent: "center",
      }}
    >
      <input type="hidden" name="public-key" value={variablesGlobales.pub_key_wompi || ""} />
      <input type="hidden" name="currency" value="COP" />
      <input type="hidden" name="amount-in-cents" value={amountInCents} />
      <input type="hidden" name="reference" value={reference} />
      <input type="hidden" name="signature:integrity" value={signature} />
      {checkoutRedirectUrl && <input type="hidden" name="redirect-url" value={checkoutRedirectUrl} />}
      <input type="hidden" name="customer-data:email" value={email || ""} />
      <input type="hidden" name="customer-data:full-name" value={fullName || ""} />
      <input type="hidden" name="customer-data:phone-number" value={phone || ""} />
      <input type="hidden" name="customer-data:phone-number-prefix" value="+57" />
      <input type="hidden" name="collect-customer-legal-id" value="true" />
      <button
        type="submit"
        style={{
          width: "100%",
          maxWidth: "360px",
          minHeight: "48px",
          border: 0,
          borderRadius: "8px",
          backgroundColor: "#4b168c",
          color: "#fff",
          fontSize: "16px",
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Continuar a Wompi
      </button>
    </form>
  );
}
